export default {
	project_name: 'Academia Protecto',
	company_agency: 'Company / Store',
	add_new_company: 'Add new Company / Store',
	no_company_agency_found: "Company / Store no encontrada",
	regionals: 'Country'
}
